var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenezuela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0154 28.6956C39.2869 26.0662 40 23.1164 40 20C40 16.8835 39.2869 13.9337 38.0154 11.3043L20 9.56519L1.9845 11.3043C0.713016 13.9337 -3.05176e-05 16.8835 -3.05176e-05 20C-3.05176e-05 23.1164 0.713016 26.0662 1.9845 28.6956L20 30.4347L38.0154 28.6956Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40C27.929 40 34.7803 35.3855 38.0153 28.6956H1.98438C5.21937 35.3855 12.0706 40 19.9998 40Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6378 23.9259L33.5815 24.7513L34.0399 26.0108L32.9285 25.2613L31.8721 26.0866L32.2414 24.798L31.1301 24.0483L32.4699 24.0016L32.8395 22.7129L33.2981 23.9726L34.6378 23.9259Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9327 19.2407L31.2224 20.3776L32.0842 21.4044L30.7834 21.0804L30.0729 22.2171L29.9792 20.8798L28.6785 20.5554L29.9217 20.0531L29.8282 18.7158L30.6899 19.7429L31.9327 19.2407Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7884 15.7632L27.5098 17.0745L28.6708 17.7448L27.3376 17.8854L27.0588 19.1963L26.5135 17.9718L25.1801 18.1117L26.1766 17.2147L25.6313 15.9901L26.7923 16.6603L27.7884 15.7632Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7047 13.913L22.8915 15.2405L24.2115 15.4732L23.0067 16.0612L23.1933 17.3887L22.2621 16.4243L21.0569 17.0119L21.6865 15.8281L20.7551 14.8639L22.0754 15.0966L22.7047 13.913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2949 13.913L17.9244 15.0966L19.2444 14.8637L18.3134 15.8284L18.9425 17.0121L17.7376 16.4243L16.8062 17.3884L16.993 16.0612L15.7881 15.4735L17.1084 15.2405L17.2949 13.913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2112 15.7632L13.2076 16.6603L14.3683 15.9901L13.8232 17.2151L14.8194 18.112L13.4862 17.9718L12.9407 19.1963L12.6624 17.8851L11.3291 17.7451L12.49 17.0747L12.2112 15.7632Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06694 19.2407L9.31014 19.7429L10.1716 18.716L10.0783 20.0536L11.3212 20.5558L10.0205 20.88L9.92679 22.2171L9.21663 21.0805L7.91577 21.4046L8.77749 20.3776L8.06694 19.2407Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36188 23.9258L6.70188 23.9725L7.16016 22.713L7.53008 24.0018L8.86969 24.0486L7.75828 24.7982L8.12766 26.0868L7.07141 25.2615L5.95992 26.011L6.41844 24.7513L5.36188 23.9258Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0153 11.3043C34.7803 4.61433 27.929 -0.00012207 19.9998 -0.00012207C12.0706 -0.00012207 5.21937 4.61433 1.98438 11.3043H38.0153Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenezuela);
export default __webpack_public_path__ + "static/media/venezuela.191c3bf40c1293496ca38136aa6c64dd.svg";
export { ForwardRef as ReactComponent };